import { useTranslation } from "react-i18next";
import PolicyPage, { PolicySection } from "../../components/policy/PolicyPage";

function PoliticaPrivacidad() {
    const { t } = useTranslation();

    return (
        <PolicyPage title={t("policyPrivacidad.title")}>
            <PolicySection title={t("policyPrivacidad.sec1.title")}>
                <p>{t("policyPrivacidad.sec1.intro")}</p>
                <ul>
                    {t("policyPrivacidad.sec1.items", { returnObjects: true }).map((item, i) => (
                        <li key={i}>{item}</li>
                    ))}
                </ul>
                <p>{t("policyPrivacidad.sec1.outro")}</p>
            </PolicySection>

            <PolicySection title={t("policyPrivacidad.sec2.title")}>
                <p>{t("policyPrivacidad.sec2.intro")}</p>
                <ul>
                    {t("policyPrivacidad.sec2.items", { returnObjects: true }).map((item, i) => (
                        <li key={i}>{item}</li>
                    ))}
                </ul>
            </PolicySection>

            <PolicySection title={t("policyPrivacidad.sec3.title")}>
                <p>{t("policyPrivacidad.sec3.body")}</p>
            </PolicySection>

            <PolicySection title={t("policyPrivacidad.sec4.title")}>
                <p>{t("policyPrivacidad.sec4.intro")}</p>
                <ul>
                    {t("policyPrivacidad.sec4.items", { returnObjects: true }).map((item, i) => (
                        <li key={i}>{item}</li>
                    ))}
                </ul>
            </PolicySection>

            <PolicySection title={t("policyPrivacidad.sec5.title")}>
                <p>{t("policyPrivacidad.sec5.intro")}</p>
                <ul>
                    {t("policyPrivacidad.sec5.items", { returnObjects: true }).map((item, i) => (
                        <li key={i}>{item}</li>
                    ))}
                </ul>
            </PolicySection>

            <PolicySection title={t("policyPrivacidad.sec6.title")}>
                <p>{t("policyPrivacidad.sec6.body")}</p>
            </PolicySection>

            <PolicySection title={t("policyPrivacidad.sec7.title")}>
                <p>{t("policyPrivacidad.sec7.body")}</p>
            </PolicySection>

            <PolicySection title={t("policyPrivacidad.sec8.title")}>
                <p>{t("policyPrivacidad.sec8.intro")}</p>
                <ul>
                    <li>{t("policyPrivacidad.sec8.email")}: <a href="mailto:emmpieza@gmail.com">emmpieza@gmail.com</a></li>
                    <li>{t("policyPrivacidad.sec8.whatsapp")}: <a href="https://wa.me/573118569675">+57 311 856 9675</a></li>
                </ul>
            </PolicySection>
        </PolicyPage>
    );
}

export default PoliticaPrivacidad;
